import { apiRequest } from "../util/apiUtils";

export const commentList = async (params) => {
  try {
    const res = await apiRequest("get", `comment/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
// export const commentAddEdit = async (payload) => {
//   try {
//     const res = await apiRequest(
//       payload?.id ? "put" : "post",
//       `comment/${payload?.id ? "edit" : "add"}`,
//       {
//         body: payload,
//       },
//       "multipart/form-data"
//     );

//     return res?.data;
//   } catch (err) {
//     throw err;
//   }
// };

export const commentDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `comment/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const commentStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `comment/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
// export const commentFeaturedChange = async (payload) => {
//   try {
//     const res = await apiRequest("patch", `comment/featured`, {
//       body: payload,
//     });

//     return res?.data;
//   } catch (err) {
//     throw err;
//   }
// };

export const commentDetails = async (postId) => {
  try {
    // const res = await apiRequest("get", `post/detail`, {
    //   queries: params,
    // });
    const res = await apiRequest("get", `comment/detail/${postId}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};
